export const QuoteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={37}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#CCC"
      d="M.644 17.988c0-2.76.95-5.69 2.852-8.789 1.927-3.125 5.39-5.976 10.39-8.554l.938 1.757c-2.5 1.771-4.349 3.256-5.547 4.453-2.11 2.162-3.164 4.232-3.164 6.211 0 .677.195 1.12.586 1.329.39.234.73.351 1.016.351.99-.13 1.64-.195 1.953-.195 1.667 0 3.034.612 4.101 1.836 1.068 1.198 1.602 2.656 1.602 4.375 0 1.927-.586 3.541-1.758 4.843-1.172 1.276-2.786 1.915-4.844 1.915-2.421 0-4.388-.86-5.898-2.579C1.387 23.197.644 20.88.644 17.988Zm21.563 0c0-2.916 1.015-5.924 3.047-9.023 2.031-3.1 5.43-5.873 10.195-8.32l.938 1.757c-2.344 1.641-4.141 3.086-5.391 4.336-2.214 2.214-3.32 4.271-3.32 6.172 0 .547.143.99.43 1.328.286.339.676.508 1.171.508.99-.13 1.64-.195 1.953-.195 1.641 0 2.995.599 4.063 1.797 1.094 1.198 1.64 2.669 1.64 4.414 0 2.031-.599 3.672-1.796 4.922-1.198 1.224-2.826 1.835-4.883 1.835-2.344 0-4.271-.859-5.782-2.578-1.51-1.744-2.265-4.062-2.265-6.953Z"
    />
  </svg>
);
